var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FaqClientMultiple"},[(!_vm.$store.state.user.isSP)?_c('FaqClientPage',{ref:"faqClient"}):_vm._e(),_vm._v(" "),(_vm.$store.state.user.isSP)?_c('FaqClientWindow',{ref:"faqClient"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bb075aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaqClientMultiple.vue
// module id = 0V2/
// module chunks = 0